import { captureException } from '@sentry/react'
import { AxiosError } from 'axios'

export const logError = (error: Error, extra?: Record<string, unknown>) => {
  if (error instanceof AxiosError) {
    console.error(error.response?.data)
    captureException(error, { extra: { ...error.response?.data, ...extra } })
  } else {
    console.error(error)
    captureException(error, { extra })
  }
}
